var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98985 10.2307C5.41144 10.2307 3.20953 10.6206 3.20953 12.1818C3.20953 13.7431 5.39747 14.1469 7.98985 14.1469C10.5683 14.1469 12.7695 13.7564 12.7695 12.1958C12.7695 10.6352 10.5822 10.2307 7.98985 10.2307Z",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98987 8.00384C9.68193 8.00384 11.0534 6.63178 11.0534 4.93971C11.0534 3.24765 9.68193 1.87622 7.98987 1.87622C6.2978 1.87622 4.92574 3.24765 4.92574 4.93971C4.92002 6.62606 6.28256 7.99812 7.96828 8.00384H7.98987Z",
    stroke: "#999999",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconRound);
export default __webpack_public_path__ + "static/media/UserIconRound.bd06f3ea.svg";
export { ForwardRef as ReactComponent };